import React, { useEffect } from "react";
import { Row, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { orderTimeline } from "../../../reducers/orderDetailsReducer";
import moment from "moment";
import CommonHeader from "../../Sub/CommonHeader";

const OrderThread = () => {
  const dispatch = useDispatch();
  const queryParameters = new URLSearchParams(window.location.search);
  const orderid = queryParameters.get("orderid");
  const order = queryParameters.get("order");
  useEffect(() => {
    dispatch(
      orderTimeline({
        id: orderid,
      })
    );
  }, []);
  const { orderTimelineData } = useSelector(
    (state) => state.orderDetailReducer
  );
  const timelineData = [
    {
      status: "Manifested",
      // date: moment(orderTimelineData?.orderDate).add(1, 'days').format("ddd, D MMMM YY"),
      details: "Manifest uploaded",
      deliveryStatus: false
    },
    {
      status: "In Transit",
      // date: moment(orderTimelineData?.orderDate).add(1, 'days').format("ddd, D MMMM YY"),
      details: "Shipment picked up",
      deliveryStatus: false
    },
    {
      status: "Yet Delivered",
      // date: orderTimelineData?.deliverdTime ? moment(orderTimelineData?.deliverdTime).subtract(2, 'days').format("ddd, D MMMM YY") : 'null',
      details: "Shipment Received at Facility",
      deliveryStatus: false
    },
    {
      status: "Dispatched",
      // date: orderTimelineData?.deliverdTime ? moment(orderTimelineData?.deliverdTime).format("ddd, D MMMM YY") : null,
      details: "Out for delivery",
      deliveryStatus: false
    },
    {
      status: "Delivery Expected",
      date: orderTimelineData?.deliverdTime ? moment(orderTimelineData?.deliverdTime).format("ddd, D MMMM YY") : null,
      details: "Your order 9282 has been deliver by",
       deliveryStatus: false
    },
  ];
  const deliveryResp = orderTimelineData?.deliveryResp || [];
  // Merge deliveryResp into timelineData
  const mergedData = timelineData.map((item, index) =>
    deliveryResp[index]
      ? {
          ...item,
          Status: deliveryResp[index]?.Status,
          deliveryStatus: true, 
        }
      : item
  );
  // const mergedData = timelineData.map((item, index) =>
  //  deliveryResp[index]
  //     ? console.log("fewfwfwf")
  //     : item
  // );
  // console.log("orderTimelineData?.deliverdTime", orderTimelineData)
  return (
    <>
    <CommonHeader/>
     <div className="container-fluid">
      <Row className="">
        <Container className="r-main-tbl mt-3">
          <div className="section__head d-md-flex justify-content-between mb-40">
            <div className="section__title">
              <h2 className="text-black">
                <b>Order ID {order}</b>
              </h2>
            </div>
          </div>
          <div className="timeline-container">
            {orderTimelineData?.statusTime?.map((item, index) => {
              return (
                <>
                  {(item.status === 0 || item.status === 2) && (
                    <div key={index} className="timeline-item">
                      <div className="timeline-dot" />
                      <div className="timeline-content">
                        <h3>
                          {(item.status === 0 && "Order Placed") ||
                            (item.status === 2 && "Order Confirmed")}{" "}
                          <span>
                            {moment(item?.time).format("ddd, D MMMM YY")}
                          </span>
                        </h3>
                        <p>{item?.comment}</p>
                      </div>
                    </div>
                  )}
                </>
              );
            })}
            {/* delivery status */}
            {mergedData?.map((item, index) => (
            <div key={index} className="timeline-item">
              <div className={`${item.deliveryStatus ? `timeline-dot` : `timeline-dot timeline-dot-orange`}`} />
              <div className={`${item.deliveryStatus ? `timeline-content` : `timeline-content timeline-content-orange`}`}>
                <h3>
                  {item?.Status?.Status || item.status}
                  <span>
                    {((item?.Status?.StatusDateTime || item.date) && item.date !== "null") && moment(item?.Status?.StatusDateTime || item.date).format("ddd, D MMMM YY")}
                  </span>
                </h3>
                {item?.Status ? (
                  <>
                    <p>{item?.Status?.Instructions}</p>
                    <p>{item?.Status?.StatusLocation}</p>
                  </>
                ) : (
                  <p>{item.details}</p>
                )}
              </div>
            </div>
          ))}
          </div>
        </Container>
      </Row>
    </div>
    </>
  );
};

export default OrderThread;
